import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Read language from Zustand persisted store in localStorage
function getStoredLanguage(): string | undefined {
  try {
    const stored = localStorage.getItem('language-storage');
    if (stored) {
      const parsed = JSON.parse(stored);
      return parsed.state?.language;
    }
  } catch {
    // Ignore parsing errors
  }
  return undefined;
}

// Import translations
import commonDE from '../locales/de/common.json';
import commonEN from '../locales/en/common.json';
import commonSL from '../locales/sl/common.json';
import validationDE from '../locales/de/validation.json';
import validationEN from '../locales/en/validation.json';
import validationSL from '../locales/sl/validation.json';
import navigationDE from '../locales/de/navigation.json';
import navigationEN from '../locales/en/navigation.json';
import navigationSL from '../locales/sl/navigation.json';
import customersDE from '../locales/de/customers.json';
import customersEN from '../locales/en/customers.json';
import customersSL from '../locales/sl/customers.json';
import objectsDE from '../locales/de/objects.json';
import objectsEN from '../locales/en/objects.json';
import objectsSL from '../locales/sl/objects.json';
import documentsDE from '../locales/de/documents.json';
import documentsEN from '../locales/en/documents.json';
import documentsSL from '../locales/sl/documents.json';
import dashboardDE from '../locales/de/dashboard.json';
import dashboardEN from '../locales/en/dashboard.json';
import dashboardSL from '../locales/sl/dashboard.json';
import servicesDE from '../locales/de/services.json';
import servicesEN from '../locales/en/services.json';
import servicesSL from '../locales/sl/services.json';
import employeesDE from '../locales/de/employees.json';
import employeesEN from '../locales/en/employees.json';
import employeesSL from '../locales/sl/employees.json';
import tasksDE from '../locales/de/tasks.json';
import tasksEN from '../locales/en/tasks.json';
import tasksSL from '../locales/sl/tasks.json';
import checklistProtocolDE from '../locales/de/checklistProtocol.json';
import checklistProtocolEN from '../locales/en/checklistProtocol.json';
import checklistProtocolSL from '../locales/sl/checklistProtocol.json';
import myChecklistsDE from '../locales/de/myChecklists.json';
import myChecklistsEN from '../locales/en/myChecklists.json';
import myChecklistsSL from '../locales/sl/myChecklists.json';
import absencesDE from '../locales/de/absences.json';
import absenceSettingsDE from '../locales/de/absenceSettings.json';
import absencesEN from '../locales/en/absences.json';
import absenceSettingsEN from '../locales/en/absenceSettings.json';
import absencesSL from '../locales/sl/absences.json';
import absenceSettingsSL from '../locales/sl/absenceSettings.json';
import planningDE from '../locales/de/planning.json';
import planningEN from '../locales/en/planning.json';
import planningSL from '../locales/sl/planning.json';
import profileDE from '../locales/de/profile.json';
import profileEN from '../locales/en/profile.json';
import profileSL from '../locales/sl/profile.json';
import authDE from '../locales/de/auth.json';
import authEN from '../locales/en/auth.json';
import authSL from '../locales/sl/auth.json';
import headerDE from '../locales/de/header.json';
import headerEN from '../locales/en/header.json';
import headerSL from '../locales/sl/header.json';
import priceIndexDE from '../locales/de/priceIndex.json';
import priceIndexEN from '../locales/en/priceIndex.json';
import priceIndexSL from '../locales/sl/priceIndex.json';
import workScheduleModelsDE from '../locales/de/workScheduleModels.json';
import workScheduleModelsEN from '../locales/en/workScheduleModels.json';
import workScheduleModelsSL from '../locales/sl/workScheduleModels.json';
import reportsDE from '../locales/de/reports.json';
import reportsEN from '../locales/en/reports.json';
import reportsSL from '../locales/sl/reports.json';
import myplanDE from '../locales/de/myplan.json';
import myplanEN from '../locales/en/myplan.json';
import myplanSL from '../locales/sl/myplan.json';
import timeclockDE from '../locales/de/timeclock.json';
import timeclockEN from '../locales/en/timeclock.json';
import timeclockSL from '../locales/sl/timeclock.json';
import offersDE from '../locales/de/offers.json';
import offersEN from '../locales/en/offers.json';
import offersSL from '../locales/sl/offers.json';
import invoicesDE from '../locales/de/invoices.json';
import invoicesEN from '../locales/en/invoices.json';
import invoicesSL from '../locales/sl/invoices.json';
import textSnippetsDE from '../locales/de/textSnippets.json';
import textSnippetsEN from '../locales/en/textSnippets.json';
import textSnippetsSL from '../locales/sl/textSnippets.json';
import tenantSettingsDE from '../locales/de/tenantSettings.json';
import tenantSettingsEN from '../locales/en/tenantSettings.json';
import tenantSettingsSL from '../locales/sl/tenantSettings.json';
import errorsDE from '../locales/de/errors.json';
import errorsEN from '../locales/en/errors.json';
import errorsSL from '../locales/sl/errors.json';
import adminDE from '../locales/de/admin.json';
import adminEN from '../locales/en/admin.json';
import adminSL from '../locales/sl/admin.json';
import publicDE from '../locales/de/public.json';
import publicEN from '../locales/en/public.json';
import publicSL from '../locales/sl/public.json';
import supportDE from '../locales/de/support.json';
import supportEN from '../locales/en/support.json';
import supportSL from '../locales/sl/support.json';
import subscriptionDE from '../locales/de/subscription.json';
import subscriptionEN from '../locales/en/subscription.json';
import subscriptionSL from '../locales/sl/subscription.json';
import importDE from '../locales/de/import.json';
import importEN from '../locales/en/import.json';
import importSL from '../locales/sl/import.json';
import contractImportDE from '../locales/de/contractImport.json';
import releaseNotesDE from '../locales/de/releaseNotes.json';
import contractImportEN from '../locales/en/contractImport.json';
import releaseNotesEN from '../locales/en/releaseNotes.json';
import contractImportSL from '../locales/sl/contractImport.json';
import releaseNotesSL from '../locales/sl/releaseNotes.json';
import commonTR from '../locales/tr/common.json';
import validationTR from '../locales/tr/validation.json';
import navigationTR from '../locales/tr/navigation.json';
import customersTR from '../locales/tr/customers.json';
import objectsTR from '../locales/tr/objects.json';
import dashboardTR from '../locales/tr/dashboard.json';
import servicesTR from '../locales/tr/services.json';
import employeesTR from '../locales/tr/employees.json';
import tasksTR from '../locales/tr/tasks.json';
import absencesTR from '../locales/tr/absences.json';
import absenceSettingsTR from '../locales/tr/absenceSettings.json';
import planningTR from '../locales/tr/planning.json';
import profileTR from '../locales/tr/profile.json';
import authTR from '../locales/tr/auth.json';
import headerTR from '../locales/tr/header.json';
import priceIndexTR from '../locales/tr/priceIndex.json';
import workScheduleModelsTR from '../locales/tr/workScheduleModels.json';
import reportsTR from '../locales/tr/reports.json';
import myplanTR from '../locales/tr/myplan.json';
import timeclockTR from '../locales/tr/timeclock.json';
import offersTR from '../locales/tr/offers.json';
import invoicesTR from '../locales/tr/invoices.json';
import textSnippetsTR from '../locales/tr/textSnippets.json';
import tenantSettingsTR from '../locales/tr/tenantSettings.json';
import errorsTR from '../locales/tr/errors.json';
import adminTR from '../locales/tr/admin.json';
import publicTR from '../locales/tr/public.json';
import supportTR from '../locales/tr/support.json';
import subscriptionTR from '../locales/tr/subscription.json';
import importTR from '../locales/tr/import.json';
import contractImportTR from '../locales/tr/contractImport.json';
import releaseNotesTR from '../locales/tr/releaseNotes.json';
import commonRO from '../locales/ro/common.json';
import validationRO from '../locales/ro/validation.json';
import navigationRO from '../locales/ro/navigation.json';
import customersRO from '../locales/ro/customers.json';
import objectsRO from '../locales/ro/objects.json';
import dashboardRO from '../locales/ro/dashboard.json';
import servicesRO from '../locales/ro/services.json';
import employeesRO from '../locales/ro/employees.json';
import tasksRO from '../locales/ro/tasks.json';
import absencesRO from '../locales/ro/absences.json';
import absenceSettingsRO from '../locales/ro/absenceSettings.json';
import planningRO from '../locales/ro/planning.json';
import profileRO from '../locales/ro/profile.json';
import authRO from '../locales/ro/auth.json';
import headerRO from '../locales/ro/header.json';
import priceIndexRO from '../locales/ro/priceIndex.json';
import workScheduleModelsRO from '../locales/ro/workScheduleModels.json';
import reportsRO from '../locales/ro/reports.json';
import myplanRO from '../locales/ro/myplan.json';
import timeclockRO from '../locales/ro/timeclock.json';
import offersRO from '../locales/ro/offers.json';
import invoicesRO from '../locales/ro/invoices.json';
import textSnippetsRO from '../locales/ro/textSnippets.json';
import tenantSettingsRO from '../locales/ro/tenantSettings.json';
import errorsRO from '../locales/ro/errors.json';
import adminRO from '../locales/ro/admin.json';
import publicRO from '../locales/ro/public.json';
import supportRO from '../locales/ro/support.json';
import subscriptionRO from '../locales/ro/subscription.json';
import importRO from '../locales/ro/import.json';
import contractImportRO from '../locales/ro/contractImport.json';
import releaseNotesRO from '../locales/ro/releaseNotes.json';
import vehiclesDE from '../locales/de/vehicles.json';
import vehiclesEN from '../locales/en/vehicles.json';
import vehiclesSL from '../locales/sl/vehicles.json';
import vehiclesTR from '../locales/tr/vehicles.json';
import vehiclesRO from '../locales/ro/vehicles.json';
import openItemsDE from '../locales/de/openItems.json';
import openItemsEN from '../locales/en/openItems.json';
import openItemsSL from '../locales/sl/openItems.json';
import openItemsTR from '../locales/tr/openItems.json';
import openItemsRO from '../locales/ro/openItems.json';
import timeClockGroupsDE from '../locales/de/timeClockGroups.json';
import timeClockGroupsEN from '../locales/en/timeClockGroups.json';
import timeClockGroupsSL from '../locales/sl/timeClockGroups.json';
import timeClockGroupsTR from '../locales/tr/timeClockGroups.json';
import timeClockGroupsRO from '../locales/ro/timeClockGroups.json';

// Define resources
const resources = {
  de: {
    common: commonDE,
    validation: validationDE,
    navigation: navigationDE,
    customers: customersDE,
    objects: objectsDE,
    documents: documentsDE,
    dashboard: dashboardDE,
    services: servicesDE,
    employees: employeesDE,
    tasks: tasksDE,
    checklistProtocol: checklistProtocolDE,
    myChecklists: myChecklistsDE,
    absences: absencesDE,
    absenceSettings: absenceSettingsDE,
    planning: planningDE,
    profile: profileDE,
    auth: authDE,
    header: headerDE,
    priceIndex: priceIndexDE,
    workScheduleModels: workScheduleModelsDE,
    reports: reportsDE,
    myplan: myplanDE,
    timeclock: timeclockDE,
    offers: offersDE,
    invoices: invoicesDE,
    textSnippets: textSnippetsDE,
    tenantSettings: tenantSettingsDE,
    errors: errorsDE,
    admin: adminDE,
    public: publicDE,
    support: supportDE,
    subscription: subscriptionDE,
    import: importDE,
    contractImport: contractImportDE,
    releaseNotes: releaseNotesDE,
    vehicles: vehiclesDE,
    openItems: openItemsDE,
    timeClockGroups: timeClockGroupsDE,
  },
  en: {
    common: commonEN,
    validation: validationEN,
    navigation: navigationEN,
    customers: customersEN,
    objects: objectsEN,
    documents: documentsEN,
    dashboard: dashboardEN,
    services: servicesEN,
    employees: employeesEN,
    tasks: tasksEN,
    checklistProtocol: checklistProtocolEN,
    myChecklists: myChecklistsEN,
    absences: absencesEN,
    absenceSettings: absenceSettingsEN,
    planning: planningEN,
    profile: profileEN,
    auth: authEN,
    header: headerEN,
    priceIndex: priceIndexEN,
    workScheduleModels: workScheduleModelsEN,
    reports: reportsEN,
    myplan: myplanEN,
    timeclock: timeclockEN,
    offers: offersEN,
    invoices: invoicesEN,
    textSnippets: textSnippetsEN,
    tenantSettings: tenantSettingsEN,
    errors: errorsEN,
    admin: adminEN,
    public: publicEN,
    support: supportEN,
    subscription: subscriptionEN,
    import: importEN,
    contractImport: contractImportEN,
    releaseNotes: releaseNotesEN,
    vehicles: vehiclesEN,
    openItems: openItemsEN,
    timeClockGroups: timeClockGroupsEN,
  },
  sl: {
    common: commonSL,
    validation: validationSL,
    navigation: navigationSL,
    customers: customersSL,
    objects: objectsSL,
    documents: documentsSL,
    dashboard: dashboardSL,
    services: servicesSL,
    employees: employeesSL,
    tasks: tasksSL,
    checklistProtocol: checklistProtocolSL,
    myChecklists: myChecklistsSL,
    absences: absencesSL,
    absenceSettings: absenceSettingsSL,
    planning: planningSL,
    profile: profileSL,
    auth: authSL,
    header: headerSL,
    priceIndex: priceIndexSL,
    workScheduleModels: workScheduleModelsSL,
    reports: reportsSL,
    myplan: myplanSL,
    timeclock: timeclockSL,
    offers: offersSL,
    invoices: invoicesSL,
    textSnippets: textSnippetsSL,
    tenantSettings: tenantSettingsSL,
    errors: errorsSL,
    admin: adminSL,
    public: publicSL,
    support: supportSL,
    subscription: subscriptionSL,
    import: importSL,
    contractImport: contractImportSL,
    releaseNotes: releaseNotesSL,
    vehicles: vehiclesSL,
    openItems: openItemsSL,
    timeClockGroups: timeClockGroupsSL,
  },
  tr: {
    common: commonTR,
    validation: validationTR,
    navigation: navigationTR,
    customers: customersTR,
    objects: objectsTR,
    dashboard: dashboardTR,
    services: servicesTR,
    employees: employeesTR,
    tasks: tasksTR,
    absences: absencesTR,
    absenceSettings: absenceSettingsTR,
    planning: planningTR,
    profile: profileTR,
    auth: authTR,
    header: headerTR,
    priceIndex: priceIndexTR,
    workScheduleModels: workScheduleModelsTR,
    reports: reportsTR,
    myplan: myplanTR,
    timeclock: timeclockTR,
    offers: offersTR,
    invoices: invoicesTR,
    textSnippets: textSnippetsTR,
    tenantSettings: tenantSettingsTR,
    errors: errorsTR,
    admin: adminTR,
    public: publicTR,
    support: supportTR,
    subscription: subscriptionTR,
    import: importTR,
    contractImport: contractImportTR,
    releaseNotes: releaseNotesTR,
    vehicles: vehiclesTR,
    openItems: openItemsTR,
    timeClockGroups: timeClockGroupsTR,
  },
  ro: {
    common: commonRO,
    validation: validationRO,
    navigation: navigationRO,
    customers: customersRO,
    objects: objectsRO,
    dashboard: dashboardRO,
    services: servicesRO,
    employees: employeesRO,
    tasks: tasksRO,
    absences: absencesRO,
    absenceSettings: absenceSettingsRO,
    planning: planningRO,
    profile: profileRO,
    auth: authRO,
    header: headerRO,
    priceIndex: priceIndexRO,
    workScheduleModels: workScheduleModelsRO,
    reports: reportsRO,
    myplan: myplanRO,
    timeclock: timeclockRO,
    offers: offersRO,
    invoices: invoicesRO,
    textSnippets: textSnippetsRO,
    tenantSettings: tenantSettingsRO,
    errors: errorsRO,
    admin: adminRO,
    public: publicRO,
    support: supportRO,
    subscription: subscriptionRO,
    import: importRO,
    contractImport: contractImportRO,
    releaseNotes: releaseNotesRO,
    vehicles: vehiclesRO,
    openItems: openItemsRO,
    timeClockGroups: timeClockGroupsRO,
  },
} as const;

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getStoredLanguage() || 'de',
    fallbackLng: 'de',
    supportedLngs: ['de', 'en', 'sl', 'tr', 'ro'],
    defaultNS: 'common',
    ns: ['common', 'validation', 'navigation', 'customers', 'objects', 'documents', 'dashboard', 'services', 'employees', 'tasks', 'absences', 'planning', 'profile', 'auth', 'header', 'priceIndex', 'workScheduleModels', 'reports', 'myplan', 'timeclock', 'offers', 'invoices', 'textSnippets', 'tenantSettings', 'absenceSettings', 'errors', 'admin', 'public', 'support', 'subscription', 'import', 'contractImport', 'releaseNotes', 'myChecklists', 'checklistProtocol', 'vehicles', 'openItems', 'timeClockGroups'],

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
